import { MrfiktivProjectCustomViewFieldViewmodelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { ProjectCustomViewFieldEnum } from "@/views/project/enum/ProjectCustomViewFieldEnum";

class ProjectCustomViewFieldBase implements MrfiktivProjectCustomViewFieldViewmodelGen {
  type: ProjectCustomViewFieldEnum;
  key: string;

  constructor(field?: Partial<MrfiktivProjectCustomViewFieldViewmodelGen>) {
    this.type = (field?.type as ProjectCustomViewFieldEnum) ?? ProjectCustomViewFieldEnum.CUSTOM_FIELD;
    this.key = field?.key ?? "";
  }
}

type IProjectCustomViewField = ProjectCustomViewFieldBase;
const ProjectCustomViewField = ProjectCustomViewFieldBase;

export { IProjectCustomViewField, ProjectCustomViewField };
